





























































import Vue, { PropType } from 'vue';
import { Cv, CvSectionProfile } from '@/../gen';
// @ts-ignore
import SectionPreviewProfile from '@/components/section-preview/SectionPreviewProfile.vue';
// @ts-ignore
import SectionPreviewText from '@/components/section-preview/SectionPreviewText.vue';
// @ts-ignore
import SectionPreviewDate from '@/components/section-preview/SectionPreviewDate.vue';
// @ts-ignore
import SectionPreviewSkill from '@/components/section-preview/SectionPreviewSkill.vue';
// @ts-ignore
import SectionPreviewLink from '@/components/section-preview/SectionPreviewLink.vue';
// @ts-ignore
import SectionPreviewGallery from '@/components/section-preview/SectionPreviewGallery.vue';

import * as CvStore from '@/containers/cv/store';
import CvPreviewPageBreak from '@/components/section-preview/CvPreviewPageBreak.vue';
import { CvCvSectionWithSection } from '@/containers/cv/store';

export type PageBreakPayload = {
  cvCvSection: CvCvSectionWithSection;
  hasNowPageBreak: boolean;
};

export default Vue.extend({
  components: {
    CvPreviewPageBreak,
    SectionPreviewProfile,
    SectionPreviewText,
    SectionPreviewDate,
    SectionPreviewSkill,
    SectionPreviewLink,
    SectionPreviewGallery,
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    cvSectionProfile: {
      type: Object as PropType<CvSectionProfile>,
      default: null,
    },
    cvCvSections: {
      type: Array as () => CvStore.CvCvSectionWithSection[],
      default: () => [],
    },
    isPageBreakMode: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    makeKey(cvCvSection: CvCvSectionWithSection): string {
      return `${cvCvSection.cv_section_type}_${cvCvSection.cv_section_id}`;
    },
    onClickPageBreak(
      cvCvSection: CvCvSectionWithSection,
      hasNowPageBreak: boolean
    ) {
      const payload: PageBreakPayload = { cvCvSection, hasNowPageBreak };
      this.$emit('submit-page-break', payload);
    },
  },
});
